import { Menu, Bitcoin, TrendingUp } from "lucide-react";
import { useAuth } from "./features/AuthContext";
import { Button } from "./ui/button";

interface HeaderProps {
  onMenuClick: () => void;
}

const getPageTitle = (pathname: string) => {
  const routes: Record<string, { title: string; subtitle: string }> = {
    "/": { title: "Dashboard", subtitle: "Trading Platform Overview" },
    "/filters": { title: "Filter Management", subtitle: "Create and manage Python trading filters" },
    "/users": { title: "User Management", subtitle: "Manage users and permissions" },
    "/buckets": { title: "Bucket Management", subtitle: "Organize trading pairs into buckets" },
    "/platform-integration": { title: "Platform Integration", subtitle: "Connect your trading platform credentials" },
    "/manual-testing": { title: "Manual Scanning", subtitle: "Test filters against buckets and view results" },
    "/order-settings": { title: "Order Settings", subtitle: "Create and manage trading order configurations" },
    "/auto-trade": { title: "Auto Trade", subtitle: "Create strategies, run them, and manage subscriptions" },
    "/order-history": { title: "Order History", subtitle: "View all trading activity and results" },
    "/leader-integration":{
      title:"Leader Management",
      subtitle:"Manage leader coin or stock"},
    "/liquidation-alert":{
      title:"Telegram alerts",
      subtitle:"Manage telegram alert bots settings"},
    "/backtesting":{
      title:"Backtesting",
      subtitle:"Run async backtests and download PDF reports"},
    "/system-config":{
      title:"System Config",
      subtitle:"Toggle crypto backend services and inspect stored configuration"}
  };
  
  return routes[pathname] || { title: "Trading Platform", subtitle: "Professional Trading Dashboard" };
};

export function Header({ onMenuClick }: HeaderProps) {
  const { isCryptoEnabled,isStocksEnabled,currentTradingMode,setCurrentTradingMode} = useAuth();
  const pathname = window.location.pathname;
  const { title, subtitle } = getPageTitle(pathname);

  return (
    <header className="bg-white border-b border-gray-200 px-2 md:px-6  py-4 flex items-center justify-between">
      <div className="flex items-center space-x-4">
        <Button
          variant="ghost"
          size="sm"
          className="lg:hidden"
          onClick={onMenuClick}
        >
          <Menu className="w-5 h-5" />
        </Button>
        <div className="hidden  md:block">
          <h1 className="text-xl font-semibold text-gray-900">{title}</h1>
          <p className="text-sm text-gray-500">{subtitle}</p>
        </div>
      </div>
      
      <div className="flex items-center space-x-4">
        {/* Mode Toggle */}
        <div className="flex items-center space-x-2 bg-gray-100 rounded-lg p-1">
          {
            isCryptoEnabled && <Button
            variant="ghost"
            size="sm"
            className={`px-3 py-1 text-sm font-medium transition-colors ${
              currentTradingMode === "crypto"
                ? "bg-white text-gray-900 shadow-sm"
                : "text-gray-500"
            }`}
            onClick={() => setCurrentTradingMode("crypto")}
          >
            <Bitcoin className="w-4 h-4 mr-1" />
            Crypto
          </Button>
          }
          {
            isStocksEnabled && <Button
            variant="ghost"
            size="sm"
            className={`px-3 py-1 text-sm font-medium transition-colors ${
              currentTradingMode === "stocks"
                ? "bg-white text-gray-900 shadow-sm"
                : "text-gray-500"
            }`}
            onClick={() => setCurrentTradingMode("stocks")}
          >
            <TrendingUp className="w-4 h-4 mr-1" />
            Stocks
          </Button>
          }
        </div>
        
        <div className="flex items-center space-x-2 text-sm">
          <div className="w-2 h-2 bg-success rounded-full"></div>
          <span className="text-gray-600">Connected</span>
        </div>
      </div>
    </header>
  );
}
